<Modal title="Respond to need" actionTitle="Send" isWide={true} {isLoading} on:close={() => $uiState.activeModal = undefined} on:action={() => apply()}>
  <article class="message is-info">
    <div class="message-body">
      <p class="block">Send a message to the charity via email. You will receive a copy of the email.</p>
    </div>
  </article>
  <div class="field">
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder="Message"
            rows="10"
            bind:value={message} />
        </div>
      </div>
    </div>
  </div>
</Modal>

<script lang="ts">
  export let item : Need_v1_Doc;

  import { uiState } from '../../../../lib/uiState';
  import Modal from 'components/Modal.svelte';

  let message : string;

  let isLoading = false;

  async function apply() {

    isLoading = true;

    let firebase = window.firebase;

    await firebase.functions().httpsCallable('api-need-createneedresponse')({needId: item.id, message} as CreateNeedResponseParams);

    isLoading = false;

    $uiState.activeModal = undefined;
  }

</script>